import { Select } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { keys, useApi } from '../api';

/**
 * Rethink staff's reseller filter: '' is any reseller, `none` the customers
 * Rethink supports directly, else a reseller's id.
 */
export function ResellerFilter({
  value,
  onChange,
}: {
  value: string;
  onChange: (resellerId: string) => void;
}) {
  const api = useApi();
  const resellers = useQuery({
    queryKey: keys.resellers,
    queryFn: () => api.resellers.list(),
    staleTime: 60_000,
  });
  return (
    <Select
      aria-label="Reseller"
      size="sm"
      w={220}
      maw="100%"
      searchable
      value={value}
      onChange={(v) => onChange(v ?? '')}
      data={[
        { value: '', label: 'Any reseller' },
        { value: 'none', label: 'Direct (no reseller)' },
        ...(resellers.data?.items ?? []).map((r) => ({ value: r.id, label: r.name })),
        // A filter from a link may name a reseller the list has not loaded yet.
        ...(value && value !== 'none' && !resellers.data?.items.some((r) => r.id === value)
          ? [{ value, label: resellers.isPending ? 'Loading…' : 'Unknown reseller' }]
          : []),
      ]}
      allowDeselect={false}
    />
  );
}
